import { useId } from 'react';

/**
 * Forecast-hour picker for the ERI layer. A native select keeps it usable
 * inside both the Bootstrap Layers tab and the Tailwind SitStat card without
 * pulling in either design system.
 */
export function EriStepSelect({
  options,
  value,
  onChange,
  disabled = false,
}: {
  options: Array<{ value: string; label: string }>;
  value: string | null;
  onChange: (step: string) => void;
  disabled?: boolean;
}) {
  const id = useId();
  return (
    <div className="d-flex flex-column gap-1">
      <label htmlFor={id} className="small text-muted mb-0">
        Forecast hour
      </label>
      <select
        id={id}
        className="form-select form-select-sm"
        value={value ?? ''}
        disabled={disabled || options.length === 0}
        onChange={(e) => onChange(e.target.value)}
        onClick={(e) => e.stopPropagation()}
      >
        {options.length === 0 ? (
          <option value="">No forecast hours</option>
        ) : null}
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </div>
  );
}
